<template>
    <ui-data-table 
        :p-headers="headers"
        p-title="Produtos"
        p-read-link="products.read.one"
        p-create-link="products.create"
        p-name="products"
    />
</template>
<script>

import {uiDataTable} from '@/components/ui'
export default {
    name: 'vwProductRead',
    components: {
        uiDataTable  
    },
    data(){
        return {
            headers: [{
                text: 'id',
                value: 'id'
            }, {
                text: 'Descrição',
                value: 'descricao'
            }, {
                text: 'Cadastrado',
                value: 'criado_em'
            }, {
                text: 'Ações', 
                value: 'actions', 
                sortable: false
            }],
        }
    },
}
</script>